<template>
  <div class="box box-secondary">
    <div class="box-header with-border">
      <i class="fa fa-shopping-cart"></i>
      <h3 class="box-title">{{'latest_orders' | translate | capitalize}} <small>[{{pagination.data.length}}]</small></h3>
      <div class="box-tools pull-right">
        <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button>
        <button type="button" class="btn btn-box-tool" data-widget="remove"><i class="fa fa-times"></i></button>
      </div>
    </div>
    <div class="box-body">
      <div class="table-responsive">
        <table class="table no-margin table-hover table-striped">
          <thead>
          <tr>
            <th>{{'status' | translate}}</th>
            <th>{{'order' | translate}} ID</th>
            <th>{{'date' | translate}}</th>
            <th>{{'sales_channel' | translate}}</th>
            <th>{{'edit' | translate | capitalize}}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="order in pagination.data">
            <td>
              <template v-for="stat in order.status">
                <span :class="stat.style"><i :class="stat.icon"></i>{{stat.label | translate }}</span><br/>
              </template>
            </td>
            <td><router-link :to="'/orders/'+order.id">{{ order.ext_order_id }}</router-link></td>
            <td>{{ order.order_date  | orderDate }}<span class="fa fa-clock-o pl-5 ml-5 mr-5"></span> {{ order.order_date  | orderDate(true) }}</td>
            <td v-if="order.order_type === 'AmazonPrime'">
              <img class="img-responsive img-channel" :src="'static/img/amazon-prime.svg'">
            </td>
            <td v-else>
              <img class="img-responsive img-channel" :src="'static/img/' + order.sales_channel + '.svg'">
            </td>
            <td><router-link :to="'/orders/'+order.id"><b-btn class="btn btn-info btn-sm">{{'edit' | translate}}<i class="fa fa-edit ml-5"></i></b-btn></router-link></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="box-footer clearfix text-left">
      <a class="btn btn-success"><router-link to="/orders">{{'view_all_orders' | translate}}</router-link></a>
      <my-pagination :total="pagination.total" :per-page="pagination.per_page" :pagination="pagination"></my-pagination>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      pagination: {
        total: 0,
        per_page: 25,
        current_page: 1,
        total_pages: 0,
        data: []
      },
      paginate (type, value) {
        let self = this
        let url = ''
        url += '?&page='
        if (value === 'previous') {
          url += (this.pagination.current_page - 1)
        }
        if (value === 'next') {
          url += this.pagination.current_page >= this.pagination.last_page ? this.pagination.last_page : (this.pagination.current_page + 1)
        } else if (value !== 'next' && value !== 'previous') {
          url += value
        }
        API.get('/statistics/order' + url)
          .then(response => {
            self.pagination = response.data
            self.filterStatus()
          }, error => {
            if (this.$store.dispatch('checkError', error)) {
              error = error.response
            } else this.$router.push('/')
          })
      }
    }
  },
  methods: {
    format (name) {
      return name === 'schuhede' ? name : name.toLowerCase().substring(0, name.length - 3)
    },
    getStatus (status) {
      let statuses = []
      if (status === 'mp_cancellation') {
        statuses.push({label: 'mp_cancellation', style: 'label label-danger', icon: 'fa fa-exclamation-triangle mr-5'})
      } else {
        if (status === 'initial') {
          statuses.push({label: 'reserved', style: 'label label-primary', icon: 'fa fa-bookmark mr-5'})
        } else {
          if (status === 'canceled' || status === 'cancelled') {
            statuses.push({label: 'canceled', style: 'label label-danger', icon: 'fa fa-ban mr-5'})
          }
          if (status === 'returned') {
            statuses.push({label: 'returned', style: 'label label-warning', icon: 'fa fa-reply mr-5'})
          }
          if (status === 'shipped' || status === 'fulfilled') {
            statuses.push({label: 'shipped', style: 'label label-success', icon: 'fa fa-check mr-5'})
          }
          if (status === 'approved') {
            statuses.push({label: 'open', style: 'label label-info', icon: 'fa fa-sign-in mr-5'})
          }
        }
      }
      return statuses
    },
    filterStatus () {
      let orders = this.pagination.data
      for (let x in orders) {
        orders[x].status = this.getStatus(orders[x].status)
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      API.get('/statistics/order')
        .then(response => {
          this.pagination = response.data
          this.filterStatus()
        })
        .catch(error => {
          if (this.$store.dispatch('checkError', error)) {
            error = error.response
          } else this.$router.push('/')
        })
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tools/OrderComponent.vue